import gql from 'graphql-tag';

export default gql`
mutation insertSnippetV2($object: snippets_v2_insert_input!) {
  insert_snippets_v2_one(object: $object) {
    snippet_id
  }
}
`;
